import { observable, action, computed } from 'mobx';

import SCREENSHOTS from '../data/screenshots';

class Screenshot {

    @observable
    _screenshot = 0;
    
    @action
    setScreenshot(screenshot) {
        this._screenshot = screenshot;
    }

    @computed
    get screenshot() {
        const screenshot = this.screenshots.find((screenshot) =>  screenshot.id === this._screenshot);
        return Object.assign({}, screenshot);
    }

    @computed
    get screenshots() {
        return SCREENSHOTS;
    }
    

}

export default new Screenshot();
